import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import '../styles/reset'
import '../styles/base'

import styled from 'react-emotion'
import { colors } from '../styles/vars'

import Header from '../components/Header'
import { ThinCTA } from '../components/ThinCta'
import { Footer } from '../components/Footer'
import { Constrain } from '../components/@primitives/constrain'

const Announcement = styled('div')`
  background-color: ${colors.primary};
  color: ${colors.white};
  padding: 10px;
  text-align: center;
  
  & > div {
    max-width: 1140px;
    margin: auto;
  }
  
  p {
    margin: 0;
  }
`

const TemplateWrapper = ({ data, children }) => (
  <div>
    <Helmet
      encodeSpecialCharacters={true}
      defaultTitle="Welcome | Advanced Valve Inc."
      titleTemplate="%s | Advanced Valve Inc."
      meta={[
        { name: 'description', content: 'We serve the Southeastern United States with same-day shipment of Digester Blow Valves, Liquor Valves, Check Valves and other Digester Valves!' },
        { name: "msapplication-TileColor", content: "#ffffff"},
        { name: "theme-color", content: "#ffffff" }
      ]}
      link={[
        { rel: "apple-touch-icon", sizes: "180x180", href: "/favicon/apple-touch-icon.png" },
        { rel: "icon", type: "image/png", sizes: "32x32", href: "/favicon/favicon-32x32.png" },
        { rel: "icon", type: "image/png", sizes: "16x16", href: "/favicon/favicon-16x16.png" },
        { rel: "manifest", href: "/favicon/site.webmanifest" },
        { rel: "mask-icon", href: "/favicon/safari-pinned-tab.svg", color: "#e0272d" }
      ]}
      script={[
        {
          defer: true,
          src: "https://pro.fontawesome.com/releases/v5.0.10/js/all.js",
          integrity: "sha384-+1nLPoB0gaUktsZJP+ycZectl3GX7wP8Xf2PE/JHrb7X1u7Emm+v7wJMbAcPr8Ge",
          crossOrigin: "anonymous"
        }
      ]}
    />

    <Announcement>
      <div>
        <p>
          <small>
            We are NAF’s Exclusive Master Distributor for the entire United States.
          </small>
        </p>
      </div>
    </Announcement>

    <Header data={{ products: [...data.products.group], more: [...data.moreProducts.group] }} />

    {children()}

    <ThinCTA />

    <Footer data={data.footerProducts.group} />

  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper

export const query = graphql`
  query LayoutQuery {
    products: allMarkdownRemark(sort: {fields: [frontmatter___category]}, filter: { frontmatter: { more: { ne: true }}}) {
    group (field: frontmatter___path) {
        edges {
          node {
            frontmatter {
              path
              category
            }
          }
        }
      }
  	}
  	moreProducts: allMarkdownRemark(sort: {fields: [frontmatter___category]}, filter: { frontmatter: { more: { eq: true }}}) {
    group (field: frontmatter___path) {
        edges {
          node {
            frontmatter {
              path
              category
            }
          }
        }
      }
  	}
    footerProducts: allMarkdownRemark(sort: {fields: [frontmatter___category]}) {
      group (field: frontmatter___path) {
        edges {
          node {
            frontmatter {
              path
              category
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js